<script setup>
    import { useChannelsStore } from '@/stores/channels'

    const store = useChannelsStore()
</script>

<template>
    <div class="flex flex-wrap w-full space-y-3">
        <span class="flex w-full mt-5 text-xs text-gray-500 dark:text-gray-400 font-medium">
            O cadastro de novos canais podem acarretar em acréscimos na mensalidade. Por favor, tenha certeza ao prosseguir!
        </span>
    
        <span
            class="flex float-left text-sm text-gray-500 dark:text-gray-400 font-medium cursor-pointer hover:opacity-75 chat_transition"
            @click="store.formStep = 1"
        >
            Ver instruções do canal
        </span>
    </div>
</template>
